var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgFacebookMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 994 994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 497,
    y1: 1003,
    x2: 497,
    y2: 9.0126,
    gradientTransform: "matrix(1 0 0 -1 0 1003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006AFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient)",
    d: "M497,0C217,0,0,205.1,0,482.1C0,627,59.4,752.2,156.1,838.7c8.1,7.3,13,17.4,13.4,28.3 l2.7,88.4c0.9,28.2,30,46.5,55.8,35.2l98.6-43.5c8.4-3.7,17.7-4.4,26.5-2c45.3,12.5,93.6,19.1,143.9,19.1 c280,0,497-205.1,497-482.1S777,0,497,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M198.6,623.1l146-231.6c23.2-36.8,73-46,107.8-19.9l116.1,87.1c10.7,8,25.3,7.9,35.9-0.1 l156.8-119c20.9-15.9,48.3,9.2,34.2,31.4L649.5,602.5c-23.2,36.8-73,46-107.8,19.9l-116.1-87.1c-10.7-8-25.3-7.9-35.9,0.1 L232.8,654.5C211.9,670.4,184.5,645.3,198.6,623.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMessenger);
export default __webpack_public_path__ + "static/media/facebook-messenger.6c324e97bfdc1c064430057fd48b725b.svg";
export { ForwardRef as ReactComponent };